<template>
  <div>
    <div
      v-if="$can('update', 'supplier')"
      class="btn-actions-content d-flex"
    >
      <b-button
        v-if="edit"
        class="d-flex align-items-center mr-3 button-cancel"
        variant="outline-primary"
        @click="cancel()"
      >
        <VSIcons
          name="CloseSquare"
          width="22"
          height="22"
          class="pr-2"
        />
        <span>Cancelar</span>
      </b-button>
      <b-button
        v-if="!edit"
        class="btn-grad d-flex align-items-center"
        @click="setEdit(true)"
      >
        <VSIcons
          name="Edit"
          width="22"
          height="22"
          class="pr-2"
        />
        <span>Editar</span>
      </b-button>
      <b-button
        v-else
        class="btn-grad d-flex align-items-center"
        type="submit"
        @click="saveChanges(supplierData)"
      >
        <VSIcons
          name="TickSquare"
          width="22"
          height="22"
          class="pr-2"
        />
        <span>Salvar</span>
      </b-button>
    </div>
    <div v-if="!apiInCall">
      <validation-observer ref="form">
        <h6>Dados do fornecedor</h6>
        <b-form
          class="mt-3"
          @submit.prevent="saveChanges(supplierData)"
        >
          <b-row>
            <b-col>
              <b-form-group
                v-slot="{ ariaDescribedby }"
                label="Pessoa Jurídica"
                :disabled="!edit"
              >
                <b-form-radio-group
                  v-model="supplierData.isLegalPerson"
                  :options="optionsLegalPerson"
                  :aria-describedby="ariaDescribedby"
                  name="radio-inline"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              v-if="supplierData.isLegalPerson"
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="CNPJ"
                rules="required|cnpj"
              >
                <b-form-group label="CNPJ">
                  <b-input-group>
                    <b-form-input
                      id="cnpj"
                      v-model="supplierData.cnpj"
                      v-mask="'##.###.###/####-##'"
                      :disabled="!edit"
                      type="text"
                      @blur="getDataCompanyByCnpj(supplierData.cnpj)"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-else
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="CPF"
                rules="required|cpf"
              >
                <b-form-group label="CPF">
                  <b-input-group>
                    <b-form-input
                      id="cpf"
                      v-model="supplierData.cpf"
                      v-mask="'###.###.###-##'"
                      :disabled="!edit"
                      type="text"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="supplierData.isLegalPerson"
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                name="nome fantasia"
                rules="required|alpha_spaces|max:100"
              >
                <b-form-group label="Nome fantasia">
                  <b-input-group>
                    <b-form-input
                      id="nome-fantasia"
                      v-model="supplierData.fantasy_name"
                      type="text"
                      :disabled="!edit"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-else
              md="3"
            >
              <validation-provider
                v-slot="{ errors }"
                name="nome completo"
                rules="required|alpha_spaces|max:100"
              >
                <b-form-group label="Nome Completo">
                  <b-input-group>
                    <b-form-input
                      id="nome-completo"
                      v-model="supplierData.full_name"
                      type="text"
                      :disabled="!edit"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="!supplierData.isLegalPerson"
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="documento de identificação"
                rules="max:100"
              >
                <b-form-group label="Documento de Identificação">
                  <b-input-group>
                    <b-form-input
                      id="documento-identificacao"
                      v-model="supplierData.identification_document"
                      type="text"
                      :disabled="!edit"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="!supplierData.isLegalPerson"
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="órgão emissor"
                rules="max:100"
              >
                <b-form-group label="Órgão Emissor">
                  <b-input-group>
                    <b-form-input
                      id="orgao-emissor"
                      v-model="supplierData.document_issuer"
                      type="text"
                      :disabled="!edit"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="supplierData.isLegalPerson"
              md="2"
            >
              <validation-provider
                v-slot="{ errors }"
                name="razão social"
                rules="required|max:100"
              >
                <b-form-group label="Razão Social">
                  <b-input-group>
                    <b-form-input
                      id="razao-social"
                      v-model="supplierData.project_name"
                      :disabled="!edit"
                      type="text"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col
              v-if="supplierData.isLegalPerson"
              md="2"
            >
              <b-form-group label="CNAE Principal">
                <b-input-group>
                  <b-form-input
                    id="cnae"
                    v-model="supplierData.main_cnae"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              v-if="supplierData.isLegalPerson"
            >
              <b-form-group label="Inscrição Estadual">
                <b-input-group>
                  <b-form-input
                    id="inscricao-estadual"
                    v-model="supplierData.state_registration"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col
              v-if="supplierData.isLegalPerson"
            >
              <b-form-group label="Inscrição Municipal">
                <b-input-group>
                  <b-form-input
                    id="inscricao-municipal"
                    v-model="supplierData.municipal_registration"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Site">
                <b-input-group>
                  <b-form-input
                    id="inscricao-municipal"
                    v-model="supplierData.website"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <validation-provider
                v-slot="{ errors }"
                name="serviço"
                rules="required"
              >
                <b-form-group label="Serviço">
                  <b-input-group>
                    <b-form-input
                      id="services"
                      v-model="supplierData.services"
                      :disabled="!edit"
                      type="text"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form>

        <h6>Endereço do fornecedor</h6>
        <b-form class="mt-3">
          <b-row>
            <b-col md="2">
              <validation-observer ref="cep">
                <validation-provider
                  v-slot="{ errors }"
                  name="CEP"
                  rules="max:9|min:8"
                >
                  <b-form-group label="CEP">
                    <b-input-group>
                      <b-form-input
                        id="cep"
                        v-model="supplierData.zip_code"
                        :disabled="!edit"
                        type="text"
                        @blur="getAddress(supplierData.zip_code)"
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </validation-observer>
            </b-col>
            <b-col md="2">
              <validation-provider
                v-slot="{ errors }"
                name="cidade"
                rules="alpha_spaces|max:50"
              >
                <b-form-group label="Cidade">
                  <b-input-group>
                    <b-form-input
                      id="cidade"
                      v-model="supplierData.city"
                      :disabled="!edit"
                      type="text"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="2">
              <b-form-group label="UF">
                <b-input-group>
                  <b-form-input
                    id="uf"
                    v-model="supplierData.state"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Bairro">
                <b-input-group>
                  <b-form-input
                    id="bairro"
                    v-model="supplierData.neighborhood"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Endereço">
                <b-input-group>
                  <b-form-input
                    id="endereco"
                    v-model="supplierData.address"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Número / Complemento">
                <b-input-group>
                  <b-form-input
                    id="numero"
                    v-model="supplierData.address_number"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>

        <h6>Dados do responsável</h6>
        <b-form class="mt-3">
          <b-row>
            <b-col md="3">
              <validation-provider
                v-slot="{ errors }"
                name="nome responsável"
                rules="alpha_spaces|max:50"
              >
                <b-form-group label="Nome">
                  <b-input-group>
                    <b-form-input
                      id="nome-responsavel"
                      v-model="contact.name"
                      :disabled="!edit"
                      type="text"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="3">
              <validation-provider
                v-slot="{ errors }"
                name="e-mail"
                rules="email|max:50"
              >
                <b-form-group label="E-mail">
                  <b-input-group>
                    <b-form-input
                      id="email-responsavel"
                      v-model="contact.email"
                      :disabled="!edit"
                      type="email"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="2">
              <b-form-group label="Departamento">
                <b-input-group>
                  <b-form-input
                    id="departamento-responsavel"
                    v-model="contact.department"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Cargo">
                <b-input-group>
                  <b-form-input
                    id="carg-responsavel"
                    v-model="contact.job_position"
                    :disabled="!edit"
                    type="text"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Data de nascimento">
                <b-input-group>
                  <b-form-input
                    id="data-responsavel"
                    v-model="contact.birth_date"
                    :disabled="!edit"
                    type="date"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2">
              <validation-provider
                v-slot="{ errors }"
                name="telefone"
                rules="phone"
              >
                <b-form-group label="Telefone">
                  <b-input-group>
                    <b-form-input
                      id="telefone-responsavel"
                      v-model="contact.telephone[0].telephone_number"
                      v-mask="maskTelephone(contact.telephone[0].telephone_number)"
                      :disabled="!edit"
                      type="text"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col md="2">
              <b-form-group label="Marcador">
                <b-form-select
                  id="marcador"
                  v-model="contact.telephone[0].telephone_type"
                  :options="optionsMarcador"
                  :disabled="!edit"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <validation-provider
                v-slot="{ errors }"
                name="observações"
                rules="max:180"
              >
                <b-form-group label="Observações">
                  <b-form-textarea
                    id="textarea"
                    v-model="contact.note"
                    rows="2"
                    max-rows="4"
                    :disabled="!edit"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <b-spinner
      v-else
      variant="primary"
      class="general-data-spinner"
    />
  </div>
</template>

<script>
import {
  BForm, BInputGroup, BFormInput, BFormGroup, BRow, BCol, BFormTextarea, BButton, BSpinner, BFormSelect, BFormRadioGroup,
} from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { titleInverse } from '@core/utils/filter'
import VSIcons from '@/assets/icons/VSIcons.vue'
import supplier from '@/services/supplier'
import { required } from '@/@core/utils/validations/validations'
import contacts from '@/services/contacts'
import { maskPhone } from '@/@core/mixins/ui/forms'

export default {
  components: {
    BForm, BInputGroup, BFormInput, BFormGroup, BRow, BCol, BFormTextarea, BButton, VSIcons, BSpinner, BFormSelect, BFormRadioGroup,
  },
  filters: {
    titleInverse,
  },
  mixins: [
    maskPhone,
  ],
  data() {
    return {
      required,
      createSupplier: false,
      createContact: false,
      optionsLegalPerson: [
        { text: 'Sim', value: true },
        { text: 'Não', value: false },
      ],
      contact: {
        id: null,
        supplier_id: 0,
        name: '',
        email: '',
        job_position: '',
        department: '',
        birth_date: '',
        note: '',
        telephone: [
          {
            telephone_number: '',
            telephone_type: '',
            whatsapp_icon: false,
            principal_icon: true,
          },
        ],
      },
      supplierData: {
        id: null,
        isLegalPerson: true,
        cpf: '',
        document_issuer: '',
        identification_document: '',
        full_name: '',
        fantasy_name: '',
        project_name: '',
        cnpj: '',
        main_cnae: '',
        state_registration: '',
        municipal_registration: '',
        website: '',
        services: '',
        zip_code: '',
        address: '',
        address_number: '',
        neighborhood: '',
        city: '',
        state: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      edit: 'app/getItemTableEdit', apiInCall: 'app/getApiInCall', optionsMarcador: 'contacts/getOptionsMarcador',
    }),
    subTitlePersonLegal() {
      return this.supplierData.isLegalPerson ? this.supplierData.fantasy_name : this.supplierData.full_name
    },
  },
  created() {
    if (this.verifyRouteAddNewItem()) {
      this.createSupplier = true
      this.createContact = true
      this.setSubtitle('')
    } else {
      this.fetchSupplier(this.$route.params.id).then(() => { this.createContact = !this.contact.name.length > 0 })
    }
  },
  methods: {
    ...mapMutations({ setEdit: 'app/SET_ITEM_TABLE_EDIT', setSubtitle: 'app/SET_SUBTITLE', setSupplierData: 'provider/SET_PROVIDER_DATA' }),
    ...mapActions({
      fetchContacts: 'contacts/fetchContacts',
    }),
    fetchSupplier(id) {
      return new Promise(resolve => {
        supplier.getSupplierById(id).then(res => {
          this.setSupplierData(res.data)
          this.supplierData = res.data
          this.setSubtitle(this.subTitlePersonLegal)
          contacts.getContactsByRelationAndId({ relation: 'Supplier', id: this.$route.params.id }).then(resContact => {
            this.contact.supplier_id = Number(this.$route.params.id)
            if (resContact.data.filter(arr => arr.isActive).length > 0) {
              // eslint-disable-next-line prefer-destructuring
              this.contact = resContact.data.filter(filterContact => filterContact.isActive && (filterContact.telephone.filter(arrTel => arrTel.principal_icon).length > 0))[0]
            }
            resolve()
          })
        })
      })
    },
    getDataCompanyByCnpj(cnpj) {
      this.getCompanyReceitaByCnpj(cnpj).then(res => {
        this.supplierData.fantasy_name = res.fantasia
        this.supplierData.project_name = res.nome
        this.supplierData.main_cnae = res.atividade_principal[0].code

        const cep = res.cep.replace(/\D/gim, '')
        this.supplierData.zip_code = cep
        this.supplierData.city = titleInverse(res.municipio)
        this.supplierData.address = titleInverse(res.logradouro)
        this.supplierData.neighborhood = titleInverse(res.bairro)
        this.supplierData.state = res.uf
        this.supplierData.address_number = res.numero
      })
    },
    saveChanges(form) {
      this.$refs.form.validate().then(success => {
        if (success) {
          if (this.supplierData.isLegalPerson) {
            this.supplierData.cpf = ''
          } else this.supplierData.cnpj = ''

          if (this.createSupplier) {
            supplier.createSupplier(form).then(res => {
              this.setEdit(false)
              this.supplierData.id = res.data.id
              this.createSupplier = false
              this.setSupplierData(res.data)
              this.saveContact(res.data.id).then(() => { this.createContact = false })
              this.toast({
                title: 'Criado!',
                text: 'Fornecedor criado com sucesso!',
                variant: 'success',
              })
              this.$router.push(`/fornecedor/${res.data.id}/detalhes`)
            })
          } else {
            supplier.editSupplier(form).then(res => {
              this.setEdit(false)
              this.toast({
                title: 'Atualizado!',
                text: 'Fornecedor atualizado com sucesso!',
                variant: 'success',
              })
              if (this.createContact) {
                this.saveContact(res.data.id).then(() => { this.createContact = false })
              } else {
                this.editContact()
              }
            })
          }
          this.setSubtitle(this.subTitlePersonLegal)
        }
      })
    },

    saveContact(id) {
      this.contact.supplier_id = id
      return new Promise((resolve, reject) => {
        if (this.contact.telephone[0].telephone_type === 'WhatsApp') this.contact.telephone[0].whatsapp_icon = true
        if (this.contact.name.length > 0) {
          contacts.createContact(this.contact).then(resContact => {
            this.contact.id = resContact.data.id
            this.fetchContacts()
            if (this.createContact) {
              this.contact.telephone[0].id = resContact.data.telephone.length > 0 ? resContact.data.telephone[0].id : null
            }
            resolve(resContact)
          }).catch(err => reject(err))
        }
      })
    },

    editContact() {
      contacts.editContact(this.contact).then(() => {
        this.fetchContacts()
      })
    },

    cancel() {
      this.setEdit(false)
      if (this.createSupplier) {
        this.$router.push({ name: 'provider' })
      } else {
        this.fetchSupplier(this.$route.params.id)
      }
    },

    getAddress(cep) {
      this.$refs.cep.validate().then(success => {
        if (success) {
          const address = this.getAdressByCep(cep)
          this.supplierData.address = address.logradouro
          this.supplierData.neighborhood = address.bairro
          this.supplierData.state = address.uf
          this.supplierData.city = address.localidade
          this.supplierData.address_number = address.complemento
        }
      })
    },
  },
}
</script>
